import React, { useContext, useEffect, useState } from 'react';
import { BsAward, BsCheck, BsExclamation, BsFolderPlus } from 'react-icons/bs';
import colors from '../../../assets/styles/colors';
import Alert from '../../../components/Alert';
import { SecondaryLargeButton } from '../../../components/Buttons/styles';
import FormTemplate from '../../../components/FormTemplate';
import { H5, H6 } from '../../../components/Typography/styles';
import { Form, FormFooter, FormRow } from '../../../components/FormTemplate/styles';
import {
  ValidationCheckContent,
  ValidationCheckIcon
} from './styles';
import { clientRegistrationSteps, identityValidationSteps } from '../../../helpers/enum';
import { IdentityValidationContext } from '../../../store';
import ModalInfo from '../../../components/ModalInfo';
import ModalActionCongratulations from '../../../components/ModalActionCongratulations';
import Loader from '../../../components/Loader';
import { useForm, Controller } from 'react-hook-form';
import { getAdoCode, validateAdoCode } from '../../../services/ado';
import InputDefault from '../../../components/InputDefault';
import RadioButtonForm from '../../../components/RadioButtonForm';
import { useHistory } from 'react-router-dom';
import { validateIdentitySupplier, validateMetaMapCode } from '../../../services/metamap';
import { validateAnteia } from '../../../services/anteia';
import { getDataValidacion } from '../../../services/IdentityValidation';
import { enviarNotificacionHabeasData, enviarNotificacionValidacionIdentidad, validacionIdentidadWhoIsWho } from '../../../services/habeasData';

const ValidationCheckPage = ({ setActiveStep, setLastStep }) => {
  const session = JSON.parse(localStorage.getItem('@EC-session'));
  const history = useHistory();
  const { register, control, errors, handleSubmit, trigger, setValue } = useForm();
  const { identityValidation, setIdentityValidation } = useContext(IdentityValidationContext);
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [showModalInfoNoValida, setShowModalInfoNoValida] = useState(false);
  const [showModalInfoADO, setShowModalInfoADO] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showAdoCode, setShowAdoCode] = useState(false);
  const [origenCodigo, setOrigenCodigo] = useState({ label: '', value: '' });
  const [ado, setAdo] = useState(false);
  const [superaIntentosAdo, setSuperaIntentosAdo] = useState(false);
  const [validationMesagge, setValidationMesagge] = useState('');
  const [validationTittle, setValidationTittle] = useState('');
  const [estadoValidacion, setEstadoValidacion] = useState('');
  const [textButton, setTextButton] = useState('');
  const [disabledButton, setDisabledButton] = useState(false);
  const [showModalInfoWhoisWho, setShowModalInfoWhoisWho] = useState(false);
  const [superaIntentosVeriff, setSuperaIntentosVeriff] = useState(false);

  /*async function acceptIdentityValidation() {
    try {
      setShowModalInfoADO(false);
      setIsLoading(true);

      const data = {
        idCredito: identityValidation.credit.id,
        idCliente: identityValidation.credit.idCliente,
        idUsuario: session.idAsesor
      }
      setIsLoading(false);
      history.push({
        pathname: '/admin/client-registration/',
        step: clientRegistrationSteps.IDENTITY_FOTO,
        idCredit: data.idCredito,
        idSimulation: identityValidation.solicitation.simulacion.idSimulacion
      });
    } catch (error) {
      setIsLoading(false);
      console.log(error.response)
    }
  }*/

  async function onSubmit(dataa) {
    try {
      setIsLoading(true);
      if (superaIntentosAdo) {
        const data = {
          code: dataa.adoSegmentCode.trim(),
          idAsesor: session.idAsesor,
          idAutovalidation: estadoValidacion.id,
          idCredito: estadoValidacion.idCredito,
          idCliente: identityValidation.credit.idCliente
        }
        const response = await validacionIdentidadWhoIsWho(data);
        setIsLoading(false);
        setShowModalInfoWhoisWho(true);
      } else {
        const data = {
          enlaceVariable: estadoValidacion.enlaceVariable,
          idCredito: estadoValidacion.idCredito
        }
        const response = await enviarNotificacionValidacionIdentidad(data);
        setIsLoading(false);
        setShowModalInfoADO(true);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error.response)
    }
  }


  function setOrigenCodigoChecked(radio) {
    setOrigenCodigo(radio);
  }

  async function initializeStateComponent() {
    try {
      setIsLoading(true);
      const response = await getDataValidacion(identityValidation.credit.id);
      setEstadoValidacion(response.data);
      setValidationMesagge(response.data.mensaje);
      if (response.data.mensaje && response.data.intentoValidacion <= 3) {
        setShowModalInfo(true);
      }

      setConfigButton(response.data);

      let proveedor = response.data.proveedor;
      let intentos = response.data.intentoValidacion;
      let idTransaccion = response.data.idTransacionProveedor || ''; // Provide a default value if idTransacionProveedor is null/undefined

      if (intentos >= 3) {
        proveedor = 'WHO_IS_WHO';
        setShowAdoCode(false);
        setSuperaIntentosAdo(true);
        setValue("adoSegmentCode", '');
      } else {
        setShowAdoCode(true);
        if (proveedor === 'ADO') {
          setSuperaIntentosAdo(false);
          setValue("adoSegmentCode", idTransaccion);
        } else if (proveedor === 'VERIFF') {
          setSuperaIntentosVeriff(false);
          setValue("adoSegmentCode", idTransaccion);
        }
      }

      setOrigenCodigoChecked({ label: proveedor, value: proveedor });


      console.log(identityValidation.credit.idCliente)
      setIsLoading(false);
    } catch (error) {
      console.log(error)
    }
  }


  function setConfigButton(data) {
    try {
      if (data?.estadoValidacion === 'EXITOSA' || data?.estadoValidacion === 'RECHAZADA') {
        setDisabledButton(true);
      } else {
        if (data?.numeroIntentoEnvio >= 2 && data?.intentoValidacion < 3) {
          setTextButton("Reenviar Notificación");
          setDisabledButton(true);
        } else if (data?.intentoValidacion >= 3) {
          setTextButton("Enviar");
          setDisabledButton(false);
        } else {
          setTextButton(data?.numeroIntentoEnvio < 1 ? 'Enviar Notificación' : "Reenviar Notificación");
          setDisabledButton(false);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }


  const getEstadoColor = (estado) => {
    switch (estado) {
      case 'PENDIENTE':
        return colors.yellow;
      case 'RECHAZADA':
        return colors.bgDanger;
      case 'EXITOSA':
        return colors.bgSuccess;
      default:
        return colors.textPrimary;
    }
  }

  useEffect(() => {
    initializeStateComponent();
  }, []);


  return (
    <FormTemplate
      idForm="identity-validation-step-page"
      activeStep="1/1"
      stepLabel="Validación de identidad">
      <br></br>
      <H5 color={colors.textPrimary}>Antes de proceder con el análisis de crédito, el cliente debe completar exitosamente la validación de identidad</H5>
      <Form onSubmit={handleSubmit(onSubmit)}>
      <FormRow col="2">
        <RadioButtonForm
          label="Origen validación identidad"
          setIdentificationRadioChecked={setOrigenCodigoChecked}
          selected={origenCodigo.value}
          name="origenCodigo"
          id="origenCodigo"
          radios={
            origenCodigo.value
              ? [{ label: origenCodigo.label, value: origenCodigo.value }]
              : []
          }
        />
        <div>
          <Controller
            as={InputDefault}
            control={control}
            label="Código de validación de identidad"
            name="adoSegmentCode"
            id="adoSegmentCode"
            error={errors.adoSegmentCode}
            readOnly={showAdoCode} // Correctly control readOnly based on showAdoCode state
          />
          <div>
            <H6 color={colors.textPrimary}>
              Estado validación:{' '}
              <span style={{ color: getEstadoColor(estadoValidacion?.estadoValidacion) }}>
                {estadoValidacion?.estadoValidacion}
              </span>
            </H6>
            <H6 color={colors.textPrimary}>
              Número intentos validación: {estadoValidacion?.intentoValidacion}
            </H6>
            <H6 color={colors.textPrimary}>
              Número envio notificación: {estadoValidacion?.numeroIntentoEnvio}
            </H6>
            {estadoValidacion?.fechavalidacion && (
              <>
                <H6 color={colors.textPrimary}>
                  Fecha validación: {estadoValidacion?.fechavalidacion.split(' ')[0]}
                </H6>
                <H6 color={colors.textPrimary}>
                  Hora validación: {estadoValidacion?.fechavalidacion.split(' ')[1]}
                </H6>
              </>
            )}
          </div>
        </div>
      </FormRow>
        <FormFooter justify="flex-end">
          {(!disabledButton) &&
            <SecondaryLargeButton type="submit" style={estadoValidacion?.numeroIntentoEnvio < 1 ? { background: colors.bgSecondary } : { background: colors.yellow, border: colors.yellow }}
            >{textButton}</SecondaryLargeButton>
          }

        </FormFooter>
      </Form>
      {isLoading && <Loader />}

      <ModalInfo
        open={showModalInfo}
        setShowModal={setShowModalInfo}
        title={validationTittle}
        description={validationMesagge}
        backgroundIcon={colors.grayLight}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />

      <ModalInfo
        open={showModalInfoNoValida}
        setShowModal={setShowModalInfoNoValida}
        title="El cliente no ha realizado el proceso de validación"
        description="El cliente no ha realizado el proceso de validación de identidad."
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />

      <ModalActionCongratulations
        open={showModalInfoADO}
        setShowModal={setShowModalInfoADO}
        actionFunctionUpButton={() => history.push({
          pathname: '/admin/pendientes_identidad',
        })}
        title="Validación de identidad"
        description="Enviamos una notificación al cliente a través de WhatsApp y correo electrónico para que realice la validación de identidad."
        actionLabelFunctionUpButton="Continuar"
        backgroundIcon={colors.textHyperlink}
        bodyIcon={<BsCheck size={32} color={colors.white} />} />

      <ModalActionCongratulations
        open={showModalInfoWhoisWho}
        setShowModal={setShowModalInfoWhoisWho}
        actionFunctionUpButton={() => history.push({
          pathname: '/admin/pendientes_identidad',
        })}
        title="Validación de identidad exitosa."
        actionLabelFunctionUpButton="Continuar"
        backgroundIcon={colors.textHyperlink}
        bodyIcon={<BsCheck size={32} color={colors.white} />} />


    </FormTemplate>
  )
}

export default ValidationCheckPage;
